<template>
    <div id="footer" class="clearfix">
        <div class="footer-wrapper">
            <h1>@2022 by Donald Lam</h1>
            <h1>Supported by Vue.js</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
}
</script>

<style scoped>
#footer{
    height: 150px;
    line-height: 150px;
    background-color: #46a1f1;
    color: aliceblue;
    text-align: center;
    vertical-align: center;
}
.footer-wrapper{
    margin-top: 45px;
}
h1{
    vertical-align: center;
    font-size: 15px;
    line-height: 30px;
    margin: auto auto;
}
</style>>